import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementStore from '../statement-store'
import setStatementQuery from './set-statement-query'

export default async function removeSearchTag(context: BareActionContext<StatementState, RootState>, tag: string)
{
    const form = statementStore.state.statementSearchForm
    if (form.tags.indexOf(tag) >= 0) {
        form.tags.splice(form.tags.indexOf(tag), 1)
    }
    setStatementQuery(context)

    return
}
